import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Icons for navigation

export const Partners = ({ data }) => {
  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 1024 }, items: 5 },
    desktop: { breakpoint: { max: 1024, min: 768 }, items: 4 },
    tablet: { breakpoint: { max: 768, min: 480 }, items: 3 },
    mobile: { breakpoint: { max: 480, min: 0 }, items: 2 },
  };

  const CustomButtonGroup = ({ next, previous }) => {
    return (
      <div>
        <button onClick={previous} className="carousel-btn left-btn">
          <FaChevronLeft size={24} />
        </button>
        <button onClick={next} className="carousel-btn right-btn">
          <FaChevronRight size={24} />
        </button>
      </div>
    );
  };

  return (
    <div id="partner" style={{ width: "100%", margin: "50px 0", position: "relative" }}>
      <div className="container">
        <div className="section-title text-center">
          <h2>Our Partners</h2>
        </div>
        <Carousel
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={2000}
          customTransition="transform 1000ms ease-in-out"
          transitionDuration={1000}
          showDots={true}
          arrows={false} // Hide default arrows
          renderButtonGroupOutside={true}
          customButtonGroup={<CustomButtonGroup />}
          className="partner-carousel"
        >
          {data
            ? data.map((d, i) => (
                <div key={i} className="partner-item" style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>
                  <img
                    src={d.smallImage}
                    alt={d.title}
                    style={{ maxWidth: "100px", height: "auto", margin: "auto" }}
                  />
                </div>
              ))
            : "Loading..."}
        </Carousel>
      </div>
    </div>
  );
};
